import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const ContEducation = dynamic(() => import('../components/static/continuingEducation/education'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';
import { getContinuingEducations } from "../api/continuing_educations";
function ContinuingEducation(props) {
  const meta = {
    title: "Continuing Education | Earn a Certificate | Course Descriptions | Self-Paced Courses | Bayan",
    description: "Valuable as a form of Professional Development (PD), Continuing Education, or as a way to explore our courses before officially beginning your Master's Degree studies.See a breakdown of available courses and their descriptions.Unlimited access to courses in Islamic Studies, Chaplaincy, & more at your fingertips for $10/month.It is also beneficial for high school, undergraduate and graduate students who wish to improve their Arabic language fluency",
    route: "continuing-education",
  }
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <ContEducation router={props.router} continuingEducationsData={props?.continuingEducationsData} />
      </Layout>
    </>
  );
}
export async function getServerSideProps(ctx) {
  const continuingEducationsData = await getContinuingEducations();
  return { props: { continuingEducationsData: continuingEducationsData?continuingEducationsData:null } }
}
export default withRouter(ContinuingEducation);
